import { actionChannel, call, take } from 'redux-saga/effects';

function* takeOneAtMost(channel, action) {
    const chan = yield actionChannel(channel);
    while (true) { // eslint-disable-line no-constant-condition
        const payload = yield take(chan);
        yield call(action, payload);
    }
}

export default takeOneAtMost;



// WEBPACK FOOTER //
// ./src/client/utils/takeOneAtMost.js